import { UmbracoNode } from "../../models/UmbracoNode";
import BlogPostTile from "./tiles/BlogPostTile";
import EventTile from "./tiles/EventTile";
import NewsroomDetailsTile from "./tiles/NewsroomDetailsTile";
import StoryTile from "./tiles/StoryTile";

export type FeedTileModel = {
  defaultImage: string | null
  node: UmbracoNode
}

export default function FeedTile({ defaultImage, node }: FeedTileModel) {
  switch (node.contentTypeAlias) {
    case 'blogPost':
      return <BlogPostTile node={node} defaultImage={defaultImage} />
    
    case 'story':
        return <StoryTile node={node} defaultImage={defaultImage} />

    case 'event':
        return <EventTile node={node} defaultImage={defaultImage} />
    
    case 'newsroomDetails':
        return <NewsroomDetailsTile node={node} defaultImage={defaultImage} />
  
    default:
      return (
        <div>
          <p>No tile set for "{node.contentTypeAlias}"</p>
        </div>
      )
  }
}